import request from "../../utils/request";
import { Result } from "../../models/general";

/** CO-708 — what a mass revocation touched (rows actually changed server-side). */
export interface SessionRevocationResult {
  scope: "company" | "platform";
  companyId?: number | null;
  users: number;
  tokens: number;
  authorizations: number;
  revokedAtUtc: string;
}

export interface SessionRevocationInput {
  /** Company scope: the exact company name. Platform scope: the literal "REVOKE ALL". */
  confirm: string;
  reason: string;
}

export const PLATFORM_REVOKE_PHRASE = "REVOKE ALL";

/** Operator-only. Ends every session of every user in one company. */
export async function revokeCompanySessions(companyId: number, input: SessionRevocationInput) {
  const response = await request.post<Result<SessionRevocationResult>>(
    `SessionRevocation/company/${companyId}`,
    input,
  );
  return response.data;
}

/** Operator-only. Ends every session on the platform except the caller's own. */
export async function revokePlatformSessions(input: SessionRevocationInput) {
  const response = await request.post<Result<SessionRevocationResult>>("SessionRevocation/platform", input);
  return response.data;
}
